export const SET_TRANSFER = 'GUIDE/TRANSFER/SET_TRANSFER'
export const SET_TRANSFERS = 'GUIDE/TRANSFER/SET_TRANSFERS'
